import { type Expect } from '@type-challenges/utils';
import { type FunctionComponent, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { type PickDeep } from 'type-fest';
import { Layout } from '../../components/Layout/Layout';
import { LoginForm } from '../../components/LoginForm/LoginForm';
import { authSlice } from '../../core/auth/auth.slice';
import {
  type RootState,
  type StrictSubsetOfRootState,
} from '../../core/root.state';
import { useSelector } from '../../hooks/useSelector';
import { hrefContainsPattern } from '../../utils/domain';
import styles from './LoginPage.module.css';

export type LoginPageProps = {
  children?: never;
};

export type LoginPageState = PickDeep<
  RootState,
  'auth.continueRoutePostLogout'
>;

type CheckState = Expect<StrictSubsetOfRootState<LoginPageState>>;

export const LoginPage: FunctionComponent<LoginPageProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const auth = useSelector((state: LoginPageState) => state.auth);
  const continueRoutePostLogout = useRef(auth.continueRoutePostLogout);

  useEffect(() => {
    hrefContainsPattern(globalThis.location.href);
  }, []);

  useEffect(() => {
    if (continueRoutePostLogout.current) {
      void navigate(continueRoutePostLogout.current);
      dispatch(authSlice.actions.clearContinueRoutePostLogout());
    }
  }, [continueRoutePostLogout, dispatch, navigate]);

  return (
    <Layout showPrivacyDisclaimer>
      <main className={styles.main}>
        <LoginForm />
      </main>
    </Layout>
  );
};
